import { render, staticRenderFns } from "./certificationManage.vue?vue&type=template&id=16223f1f&scoped=true&"
import script from "./certificationManage.vue?vue&type=script&lang=js&"
export * from "./certificationManage.vue?vue&type=script&lang=js&"
import style0 from "./certificationManage.vue?vue&type=style&index=0&id=16223f1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16223f1f",
  null
  
)

component.options.__file = "certificationManage.vue"
export default component.exports